var _EventTrackingProvide, _EventTrackingProvide2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { contextKeys } from './constants';

var EventTrackingProvider = function (_React$Component) {
  _inherits(EventTrackingProvider, _React$Component);

  function EventTrackingProvider() {
    _classCallCheck(this, EventTrackingProvider);

    return _possibleConstructorReturn(this, (EventTrackingProvider.__proto__ || Object.getPrototypeOf(EventTrackingProvider)).apply(this, arguments));
  }

  _createClass(EventTrackingProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _ref;

      // Since these can be nested inside one another, fallback
      // to context if the prop isn't specified, since it may be
      // coming from the context of an ancestor provider
      return _ref = {}, _defineProperty(_ref, contextKeys.CATEGORY, this.props.category || this.context[contextKeys.CATEGORY]), _defineProperty(_ref, contextKeys.ACTION, this.props.action || this.context[contextKeys.ACTION]), _defineProperty(_ref, contextKeys.LABEL, this.props.label || this.context[contextKeys.LABEL]), _defineProperty(_ref, contextKeys.VALUE, this.props.value || this.context[contextKeys.VALUE]), _ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['children']);

      var childrenWithProps = React.Children.map(children, function (child) {
        // Handle button group props not being passed to cloned children
        if (rest.spaced || rest.group) {
          return React.cloneElement(child, _extends({}, rest));
        }

        return child;
      });

      return childrenWithProps;
    }
  }]);

  return EventTrackingProvider;
}(React.Component);

export default EventTrackingProvider;


EventTrackingProvider.contextTypes = (_EventTrackingProvide = {}, _defineProperty(_EventTrackingProvide, contextKeys.CATEGORY, PropTypes.string), _defineProperty(_EventTrackingProvide, contextKeys.ACTION, PropTypes.string), _defineProperty(_EventTrackingProvide, contextKeys.LABEL, PropTypes.string), _defineProperty(_EventTrackingProvide, contextKeys.VALUE, PropTypes.number), _EventTrackingProvide);

EventTrackingProvider.childContextTypes = (_EventTrackingProvide2 = {}, _defineProperty(_EventTrackingProvide2, contextKeys.CATEGORY, PropTypes.string), _defineProperty(_EventTrackingProvide2, contextKeys.ACTION, PropTypes.string), _defineProperty(_EventTrackingProvide2, contextKeys.LABEL, PropTypes.string), _defineProperty(_EventTrackingProvide2, contextKeys.VALUE, PropTypes.number), _EventTrackingProvide2);

EventTrackingProvider.propTypes = {
  category: PropTypes.string,
  label: PropTypes.string,
  action: PropTypes.string,
  value: PropTypes.number,
  children: PropTypes.node.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/util-user-tracking/es/EventTrackingProvider.js
// module id = 1073
// module chunks = 1